<template>
	<div
		class="flex flex-row h-[50px] w-[5.625rem] bg-white shadow-sm border border-gray-300 relative"
	>
		<button
			:disabled="modelValue === min || disabled"
			data-action="decrement"
			class="pl-1 disabled:opacity-20 h-full outline-none"
			aria-label="decrease quantity"
			name="decrease quantity"
			@click="decrement"
		>
			<MinusIcon class="h-6 w-6" />
		</button>
		<input
			type="number"
			class="[appearance:textfield] flex-1 min-w-0 text-base text-center"
			:value="modelValue"
			aria-label="input quantity"
			name="input quantity"
			@input="inputUpdateQuantity"
		/>
		<button
			:disabled="!!(max && modelValue === max) || disabled"
			data-action="increment"
			class="pr-1 disabled:opacity-20 h-full outline-none"
			aria-label="increase quantity"
			name="increase quantity"
			@click="increment"
		>
			<PlusIcon class="h-6 w-6" />
		</button>
	</div>
</template>

<script setup lang="ts">
import { PlusIcon, MinusIcon } from "@heroicons/vue/24/outline";

interface Props {
	modelValue: number;
	min: number;
	max: number;
	disabled?: boolean;
}
const { modelValue, min, max, disabled } = defineProps<Props>();

const emit = defineEmits(["update:modelValue"]);

const decrement = () => {
	if (modelValue - 1 < min) {
		return;
	}
	emit("update:modelValue", modelValue - 1);
};

const increment = () => {
	if (max && modelValue + 1 > max) {
		return;
	}

	emit("update:modelValue", modelValue + 1);
};

const inputUpdateQuantity = (event: Event) => {
	const targetValue = event.target as HTMLInputElement;
	return updateQuantity(+targetValue?.value || 0);
};

const updateQuantity = (value: number) => {
	const valueInt = +value;
	if (valueInt < min) {
		emit("update:modelValue", min);
	} else if (max && valueInt > max) {
		emit("update:modelValue", max);
	} else {
		emit("update:modelValue", valueInt);
	}
};
</script>
